import React from "react";

export function AgentFilters({
  teams,
  selectedTeam,
  setSelectedTeam,
  selectedShop,
  setSelectedShop,
  loading,
  agentSearchQuery,
  setAgentSearchQuery,
  FetchDriverCall,
}) {
  return (
    <div className="px-3 py-1">
      <p className="mb-1 flex items-center justify-between text-xl lg:text-2xl font-semibold">
        <span>Agents</span>

        <button
          onClick={() => FetchDriverCall()}
          className="text-orange-500 flex-shrink-0"
        >
          ⟳
        </button>
      </p>

      <div className="flex flex-col lg:flex-row gap-4 py-2">
        {/* Team Select */}
        <div className="relative flex-1 lg:flex-none">
          <select
            className="border px-2 py-2 rounded text-sm text-gray-500 bg-white w-full lg:w-60 pr-8 appearance-none focus:outline-none focus:ring-1 focus:ring-orange-500"
            value={selectedTeam}
            onChange={(e) => setSelectedTeam(e.target.value)}
          >
            <option value="All Team">All Team</option>
            {(teams || []).map((t) => (
              <option key={t?.Id} value={t?.team_name}>
                {t?.team_name}
              </option>
            ))}
          </select>
        </div>

        {/* Shop Select */}
        <div className="relative flex-1">
          <select
            value={selectedShop}
            onChange={(e) => setSelectedShop(e.target.value)}
            disabled={loading}
            className={`w-full px-3 py-2 border text-sm text-gray-500 rounded pr-10 appearance-none focus:outline-none focus:ring-1 focus:ring-orange-500 ${loading ? "bg-gray-100" : "bg-white"
              }`}
          >
            <option value="">All Restaurants</option>

            {selectedTeam === "All Team"
              ? Array.from(
                new Map(
                  (teams || []).flatMap((t) =>
                    (t.shopList || []).map((shop) => [shop.shop_code, shop]),
                  ),
                ).values(),
              ).map((shop) => (
                <option key={shop.shop_code} value={shop.shop_code}>
                  {shop.shop_name}
                </option>
              ))
              : (
                teams.find((t) => t.team_name === selectedTeam)?.shopList ||
                []
              ).map((shop) => (
                <option key={shop.shop_code} value={shop.shop_code}>
                  {shop.shop_name}
                </option>
              ))}
          </select>
        </div>
      </div>

      {/* Search */}
      <div className="flex items-center space-x-3 text-sm w-full">
        <input
          type="text"
          placeholder="Search..."
          value={agentSearchQuery}
          onChange={(e) => setAgentSearchQuery(e.target.value)}
          className="rounded py-2 text-base border px-2 bg-white flex-1 focus:outline-none focus:ring-1 focus:ring-orange-500"
        />
      </div>
    </div>
  );
}

/*  AGENT TABS */
const agentTabs = ["all drivers", "active", "offline"];

export function AgentTabs({
  selectedAgentTab,
  setSelectedAgentTab,
  getAgentTabCount,
}) {
  return (
    <div className="flex gap-2 lg:gap-5 mt-2 text-center pb-1 mr-4 ml-3">
      {agentTabs.map((tab) => {
        const isActive = tab === selectedAgentTab;
        return (
          <div
            key={tab}
            onClick={() => setSelectedAgentTab(tab)}
            className={`flex justify-center items-center flex-1 px-1 py-2 rounded-md border cursor-pointer transition-all ${isActive
                ? "bg-blue-500 text-white"
                : "bg-white text-gray-600 border-gray-300"
              }`}
          >
            <span className="text-xs lg:text-sm font-medium whitespace-nowrap">
              {tab === "all drivers"
                ? "All Drivers"
                : tab.charAt(0).toUpperCase() + tab.slice(1)}
            </span>
            <span
              className={`ml-2 px-2 py-1 rounded-md text-xs font-bold ${isActive
                  ? "bg-blue-400 text-white"
                  : "bg-gray-100 text-gray-700"
                }`}
            >
              {getAgentTabCount ? getAgentTabCount(tab) : 0}
            </span>
          </div>
        );
      })}
    </div>
  );
}

/*  AGENT GRID */
export function AgentGrid({ agents = [], onNotify }) {
  if (!agents || agents.length === 0) {
    return (
      <div className="text-xs text-gray-400 text-center py-4">
        No agents found.
      </div>
    );
  }

  return (
    <div className="flex-1 overflow-y-auto p-1 space-y-2 ml-2 mt-2 min-h-0 max-h-96">
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
        {agents.map((agent) => (
          <div
            key={agent?.id}
            className="flex flex-col bg-white p-3 pl-4 shadow-sm rounded-md border-l-4 cursor-pointer hover: min-w-0"
            style={{
              borderLeftColor:
                agent?.dutyStatus === "active" ? "#22C55E" : "#3B82F6",
            }}
          >
            <div className="flex justify-between items-center min-w-0">
              <div className="font-semibold text-sm text-gray-900 truncate flex-1 mr-2">
                {agent?.fullName || "Unknown Driver"}
              </div>

              <div className="flex items-center gap-2 flex-shrink-0">
                <button
                  className="text-orange-600 hover:text-orange-800"
                  onClick={() => onNotify && onNotify(agent)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15 17h5l-1.405-1.405C19.79 14.79 20 13.918 20 13V9a7.002 7.002 0 00-5-6.708V2a1 1 0 00-2 0v.292A7.002 7.002 0 006 9v4c0 .918.21 1.79.595 2.595L5 17h5m5 0v1a3 3 0 11-6 0v-1m6 0H9"
                    />
                  </svg>
                </button>

                <span
                  className={`inline-flex items-center gap-1 text-xs font-medium px-2 py-0.5 rounded-full whitespace-nowrap ${agent?.dutyStatus === "active"
                      ? "bg-green-100 text-green-700"
                      : agent?.dutyStatus === "offline"
                        ? "bg-blue-100 text-blue-700"
                        : "bg-yellow-100 text-yellow-700"
                    }`}
                >
                  <span className="w-2 h-2 rounded-full bg-current" />
                  {(agent?.dutyStatus || "unknown").charAt(0).toUpperCase() +
                    (agent?.dutyStatus || "unknown").slice(1)}
                </span>
              </div>
            </div>

            {agent?.teamName && (
              <div className="flex items-center gap-2 text-xs text-gray-500 mt-1 min-w-0">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4 text-gray-400 flex-shrink-0"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M3 7h18M3 12h18M3 17h18"
                  />
                </svg>
                <span className="truncate">{agent.teamName}</span>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
